import React, { useState } from 'react';
import { Container, Form, Button, Card, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { itemService } from '../services/api';

const RegisterAdmin = () => {
    const [formData, setFormData] = useState({
        first_name: '', 
        email: '', 
        password: '', 
        household_name: ''
    });
    const [inviteCode, setInviteCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            // Payload harmonisé avec le backend
            const payload = {
                name: formData.first_name,
                email: formData.email,
                password: formData.password,
                householdName: formData.household_name
            };

            const response = await itemService.registerAdmin(payload);
            const data = await response.json();
            
            if (response.ok) {
                // Succès : on affiche le code d'invitation généré par le serveur
                setInviteCode(data.inviteCode);
            } else {
                setError(data.message || "Une erreur est survenue lors de l'inscription.");
            }
        } catch (error) {
            setError("Connexion impossible. Vérifiez votre accès internet ou l'état du serveur.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', backgroundColor: '#f4f7f6' }}>
            <Card className="border-0 shadow-lg rounded-4 p-2" style={{ maxWidth: '450px', width: '100%' }}>
                <Card.Body>
                    {!inviteCode ? (
                        <>
                            <div className="text-center mb-4">
                                <div className="display-6 mb-2">🛒</div>
                                <h2 className="fw-bold text-success">Créer un foyer</h2>
                                <p className="text-muted">Partagez votre liste de courses en famille</p>
                            </div>

                            {error && <Alert variant="danger" className="py-2 small text-center">{error}</Alert>}

                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="small fw-bold text-secondary">Nom du foyer</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        placeholder="Ex: Famille Martin"
                                        className="bg-light border-0 py-2"
                                        required
                                        value={formData.household_name}
                                        onChange={(e) => setFormData({...formData, household_name: e.target.value})}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label className="small fw-bold text-secondary">Votre Prénom</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        placeholder="Comment vous appelle-t-on ?"
                                        className="bg-light border-0 py-2"
                                        required
                                        value={formData.first_name}
                                        onChange={(e) => setFormData({...formData, first_name: e.target.value})}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label className="small fw-bold text-secondary">Email</Form.Label>
                                    <Form.Control 
                                        type="email" 
                                        placeholder="votre@email.com"
                                        className="bg-light border-0 py-2"
                                        required
                                        value={formData.email}
                                        onChange={(e) => setFormData({...formData, email: e.target.value})}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <Form.Label className="small fw-bold text-secondary">Mot de passe</Form.Label>
                                    <Form.Control 
                                        type="password" 
                                        placeholder="Choisir un mot de passe"
                                        className="bg-light border-0 py-2"
                                        required
                                        value={formData.password}
                                        onChange={(e) => setFormData({...formData, password: e.target.value})}
                                    />
                                </Form.Group>

                                <Button variant="success" type="submit" className="w-100 rounded-pill fw-bold py-2 shadow-sm mb-3" disabled={loading}>
                                    {loading ? 'Création en cours...' : 'Créer mon foyer'}
                                </Button>
                                
                                <div className="text-center">
                                    <Button variant="link" onClick={() => navigate('/login')} className="text-muted small text-decoration-none">
                                        Déjà un compte ? Se connecter
                                    </Button>
                                </div>
                            </Form>
                        </>
                    ) : (
                        <div className="text-center py-4">
                            <div className="display-1 mb-3">🎉</div>
                            <h4 className="fw-bold text-dark">Foyer créé avec succès !</h4>
                            <p className="text-muted">Voici votre code d'invitation unique pour rejoindre la <strong>{formData.household_name}</strong> :</p>
                            
                            <div className="bg-light p-3 rounded-4 mb-4 border border-success border-2">
                                <code className="display-6 text-success fw-bold" style={{ letterSpacing: '2px' }}>
                                    {inviteCode}
                                </code>
                            </div>

                            <p className="small text-muted mb-4">
                                Envoyez ce code aux membres de votre famille pour qu'ils puissent synchroniser leur liste avec la vôtre.
                            </p>

                            <Button variant="success" className="w-100 rounded-pill fw-bold py-2 shadow" onClick={() => navigate('/login')}>
                                Accéder à ma liste
                            </Button>
                        </div>
                    )}
                </Card.Body>
            </Card>
        </Container>
    );
};

export default RegisterAdmin;